<template>
  <div class="animated fadeIn">
    <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
    <b-card v-else>
      <template v-slot:header>
        <h5>Edit Anggota</h5>
      </template>
      <b-row class="mb-3">
        <b-col cols="12" md="6" v-if="optionsCabang.length > 2">
          <b-form-group label="Cabang">
            <multiselect name="dariCabang" v-model="filters.cabang" :options="optionsCabang" :internal-search="true"
              :allow-empty="false" deselect-label="" select-label="" label="name" track-by="name" placeholder="Semua" />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="No. Anggota">
            <b-form-input v-model="filters.noAnggota" id="filterInput" type="search" placeholder="Masukkan No. Anggota"
              @keyup.enter="onSearch()" />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Tipe">
            <b-form-select v-model="filters.tipe" id="filterTipe" name="tipe" :options="optionsTipe" />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Status">
            <b-form-select v-model="filters.status" id="filterStatus" name="status" :options="optionsStatus" />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12" lg="6">
          <b-form-group label="Tanggal">
            <div class="d-flex" :class="isMobile ? 'flex-wrap' : ''">
              <b-form-input v-model="filters.startDate" name="filterFromDate" id="filterDate" type="date"
                class="flex-fill"></b-form-input>
              <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
              <b-form-input v-model="filters.endDate" name="filterToDate" type="date" class="flex-fill"></b-form-input>
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <div class="d-flex search-input-wrapper">
            <b-button variant="pgiBtn" :disabled="isBusy" class="mr-2" @click="onSearch()">
              Search
            </b-button>
            <b-button variant="pgiBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
          </div>
        </b-col>
      </b-row>
      <div class="detail-data-wrapper">
        <b-table bordered hover show-empty :busy="isBusy" :items="data" :no-local-sorting="false" :fields="fields"
          responsive class="mb-3">
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading data...</strong>
            </div>
          </template>
          <template v-slot:empty>
            Tidak ada data.
          </template>
          <template #cell(request_info)="data">
            <div class="smallText">
              <span class="text-muted">No. Anggota:</span> {{ data.item.noAnggota }}
            </div>
            <div class="smallText">
              <span class="text-muted">Dibuat pada:</span> {{ data.item.createdAt ?
                $helper.changeDateFormat(data.item.createdAt) : '' }} - {{ data.item.createdAt ?
                $helper.changeDateFormatGetHour(data.item.createdAt) : '' }}
            </div>
            <div class="smallText">
              <span class="text-muted">Dibuat oleh:</span> {{ data.item.createdByName }}
            </div>
            <div class="smallText">
              <span class="text-muted">Cabang Pengaju:</span> {{ data.item.cabangName }}
            </div>
            <div class="smallText">
              <span class="text-muted">Diverifikasi pada: </span> {{ data.item.approvedAt ?
                $helper.changeDateFormat(data.item.approvedAt) : '' }} - {{ data.item.approvedAt ?
                $helper.changeDateFormatGetHour(data.item.approvedAt)
                : '' }}
            </div>
            <div class="smallText">
              <span class="text-muted">Diverifikasi oleh: </span> {{ data.item.approvalByName ? data.item.approvalByName
                : '-' }}
            </div>
          </template>

          <template #cell(changes)="data">
            <span class="badge badge-light border mb-1" style="border-radius: 5px;">
              {{ formatDataType(data.item.dataType) }} </span>
            <div class="d-flex align-items-center flex-wrap">
              <span class="text-muted mr-2">
                {{ data.item.valueBefore }}
              </span>
              <i class="fa fa-arrow-right text-muted mx-1"></i>
              <span class="font-weight-bold ml-2">
                {{ data.item.valueFinal ? data.item.valueFinal : data.item.valueAfter }}
              </span>
            </div>
            <div class="mt-1" v-if="formatDataType(data.item.dataType) == 'No Handphone'">
                <ModalFoto isButton withLength :photos="getPathPhotos(data.item.pathPhotos)" />
            </div>
          </template>

          <template #cell(notes)="data">
            <div class="smallText">
              <span class="text-muted">Alasan Pengajuan:</span> {{ data.item.note }}
            </div>
            <div class="smallText">
              <span class="text-muted" v-if="data.item.status != STATUS_EDIT_ANGGOTA.PENDING">Alasan {{
                getStatus(data.item.status).text }}:</span> {{ data.item.noteApproval }}
            </div>
          </template>

          <template #cell(status)="data">
            <span :class="getStatus(data.item.status).class">
              {{ getStatus(data.item.status).text }}
            </span>
          </template>
          <template #cell(action)="data">
            <div class="d-flex gap-2 flex-wrap justify-content-center">
              <template v-if="data.item.status == STATUS_EDIT_ANGGOTA.PENDING && IS_HAVE_PERMISSION_APPROVE_EDIT">
                <FieldApproval is-from-approval :imageUrl="formatDataType(data.item.dataType) == 'No Handphone' ? getImageApproval(data.item) : ''" :label="formatDataType(data.item.dataType)" :field-key="`${data.item.id}`"
                  :current-value="data.item.valueBefore" :new-value="data.item.valueAfter" :loading="false"
                  @submit="handleEditApproval" :selectedRow="data.item" :size="formatDataType(data.item.dataType) == 'No Handphone' ? 'xl' : ''" />
                <b-button size="sm" variant="danger" @click="onShowModalReject(data.item)">
                  <i class="fa fa-times"></i>
                </b-button>
              </template>
              <b-button
                size="sm"
                variant="dark"
                v-b-tooltip.hover
                title="Identitas Nasabah"
                @click="onShowModalIdentitas(data.item)"
              >
                <i class="fa fa-address-card"></i>
              </b-button>
              <b-button
                  @click="onShowModalListRekening(data.item)"
                  size="sm"
                  variant="pgiBtn"
                  v-b-tooltip.hover
                  title="Rekening Bank"
              >
                  <i class="fa fa-credit-card"></i>
              </b-button>
            </div>
          </template>
        </b-table>

        <div class="pagination-wrapper d-flex align-items-center justify-content-between">
          <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
            <b-form-select v-model="show" @change="onLimitChange" :options="optionsLimit">
              <template v-slot:first>
                <b-form-select-option :value="null" disabled />
              </template>
            </b-form-select>
            <span class="ml-2">{{ totalViewText }}</span>
          </b-input-group>
          <b-pagination class="mb-0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
            aria-controls="my-table" @input="onPageChange"></b-pagination>
        </div>
      </div>
    </b-card>

    <b-modal id="modal-identitas" title="Identitas Nasabah" size="lg">
      <StateDetailHandler :isLoading="stateListIdentitas.isLoading" :isError="stateListIdentitas.isError" :lines="5"
        @retry="getListIdentitas">
        <template v-if="selectedRow">
          <span>{{ selectedRow.row.namaAnggota }} - </span>
          <span class="status-box status-box-brand mb-2">{{ selectedRow.row.noAnggota }}</span>
        </template>
        <ListIdentitas :dataIdentitas="stateListIdentitas.data" />
      </StateDetailHandler>
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
          Tutup
        </b-button>
      </template>
    </b-modal>

    <ModalConfirm id="modal-approve" title="Konfirmasi Persetujuan Edit Anggota" :isSubmitting="isLoadingApprove"
      @submit="handleApprove">
      <div>
        <p>Apakah Anda yakin ingin menyetujui perubahan data anggota berikut?</p>
        <div class="bg-light p-3 rounded" v-if="selectedRow">
          <dl class="row mb-0">
            <dt class="col-sm-5 text-wrap">{{ formatDataType(selectedRow.row.dataType) }} Lama</dt>
            <dd class="col-sm-7 text-wrap">{{ selectedRow.oldValue }}</dd>
            <dt class="col-sm-5 text-wrap">{{ formatDataType(selectedRow.row.dataType) }} Baru</dt>
            <dd class="col-sm-7 text-wrap"><strong>{{ selectedRow.newValue }}</strong></dd>
            <dt class="col-sm-5">Alasan Setuju</dt>
            <dd class="col-sm-7 text-wrap">{{ selectedRow.notes }}</dd>
          </dl>
        </div>
      </div>
    </ModalConfirm>

    <ModalConfirm id="modal-reject" title="Penolakan Edit Anggota" @submit="onShowModalRejectDetail">
      <b-form-group label="Alasan Penolakan">
        <b-form-textarea v-model="noteReject" placeholder="Contoh: Salah ketik..." rows="4"
          maxlength="100"></b-form-textarea>
      </b-form-group>
    </ModalConfirm>

    <ModalConfirm id="modal-reject-detail" title="Konfirmasi Penolakan Edit Anggota" :isSubmitting="isLoadingReject"
      @submit="handleReject">
      <div>
        <p>Apakah Anda yakin ingin menolak perubahan data anggota berikut?</p>
        <div class="bg-light p-3 rounded" v-if="selectedRow">
          <dl class="row mb-0">
            <dt class="col-sm-5 text-wrap">{{ formatDataType(selectedRow.row.dataType) }} Lama</dt>
            <dd class="col-sm-7 text-wrap">{{ selectedRow.row.valueBefore }}</dd>
            <dt class="col-sm-5 text-wrap">{{ formatDataType(selectedRow.row.dataType) }} Baru</dt>
            <dd class="col-sm-7 text-wrap"><strong>{{ selectedRow.row.valueAfter }}</strong></dd>
            <dt class="col-sm-5 text-wrap">Alasan Penolakan</dt>
            <dd class="col-sm-7 text-wrap">{{ noteReject }}</dd>
          </dl>
        </div>
      </div>
    </ModalConfirm>

    <ModalListRekeningBank 
      :stateListRekening="stateListRekening"
      :dataListRekening="stateListRekening.data"
      :userData="selectedRow ? selectedRow.row : {}"
      :isReadOnly="true"
    />
  </div>
</template>

<script>
import CONSTANTS from '@/constants'
import FieldApproval from '@/components/common/FieldApproval'
import ListIdentitas from '@/components/common/ListIdentitas'
import StateDetailHandler from '@/components/common/StateDetailHandler'
import ModalListRekeningBank from '@/components/modals/ModalListRekeningBank'
import ModalFoto from '@/components/modals/ModalFoto'

export default {
  components: {
    FieldApproval,
    ListIdentitas,
    StateDetailHandler,
    ModalListRekeningBank,
    ModalFoto,
  },
  data() {
    return {
      initStatus: 0,
      isBusy: false,
      fields: [
        { key: 'request_info', label: 'Informasi Pengajuan', thClass: 'min-width-200', tdClass: 'min-width-200' },
        { key: 'changes', label: 'Detail Perubahan', thClass: 'max-width-200', tdClass: 'max-width-200' },
        { key: 'notes', label: 'Alasan', thClass: 'max-width-150', tdClass: 'max-width-150' },
        { key: 'status', label: 'Status', class: 'text-center' },
        { key: 'action', label: 'Aksi', class: 'text-center' }
      ],
      data: [],
      filters: {
        noAnggota: this.$helper.getParams('noAnggota'),
        tipe: '',
        status: CONSTANTS.ANGGOTA.STATUS_EDIT_ANGGOTA.PENDING,
        cabang: null,
        startDate: null,
        endDate: null,
      },
      optionsStatus: CONSTANTS.OPTIONS_STATUS_APPROVAL_EDIT_NASABAH,
      optionsTipe: CONSTANTS.OPTIONS_TIPE_EDIT_NASABAH,
      optionsCabang: [],
      currentPage: 1,
      show: 10,
      perPage: 10,
      totalRows: 0,
      totalPages: 0,
      totalViewText: "",
      optionsLimit: CONSTANTS.OPTIONS_LIMIT_PAGINATION,
      isMobile: false,
      isLoadingReject: false,
      isLoadingApprove: false,
      stateListIdentitas: {
        data: [],
        isLoading: false,
        isError: false,
      },
      selectedRow: null,
      noteReject: '',
      stateListRekening: {
        isLoading: false,
        data: [],
        error: null,
      },
    }
  },
  computed: {
    STATUS_EDIT_ANGGOTA() {
      return CONSTANTS.ANGGOTA.STATUS_EDIT_ANGGOTA
    },
    IS_HAVE_PERMISSION_APPROVE_EDIT() {
      const hasPermissionApprove = this.$helper.hasPermissionMenuChildren('ADN')

      if (hasPermissionApprove) {
        return true;
      }

      return false;
    },
  },
  methods: {
    async init() {
      this.initStatus = 0
      try {
        this.getCabang()
        await this.getItems()
        this.initStatus = 1
      } catch (error) {
        this.$helper.parseError(this, error)
        this.initStatus = -1
      }
    },
    getItems(page = 1) {
      this.isBusy = true
      this.data = []
      this.currentPage = isNaN(page) ? 1 : page

      const params = {
        page: this.currentPage - 1,
        size: this.perPage,
      }

      if (this.optionsCabang.length <= 2) {
        this.filters.cabang = this.optionsCabang[1]
      }

      if (!this.$helper.isNullOrEmpty(this.filters.cabang)) {
        params.cabangId = this.filters.cabang.id;
      }

      if (!this.$helper.isNullOrEmpty(this.filters.noAnggota)) {
        params.noAnggota = this.filters.noAnggota;
      }

      if (!this.$helper.isNullOrEmpty(this.filters.status) || this.filters.status === this.STATUS_EDIT_ANGGOTA.PENDING) {
        params.status = this.filters.status;
      }

      if (!this.$helper.isNullOrEmpty(this.filters.tipe)) {
        params.dataType = this.filters.tipe;
      }

      if (!this.$helper.isNullOrEmpty(this.filters.startDate)) {
        params.startDate = this.filters.startDate;
      }

      if (!this.$helper.isNullOrEmpty(this.filters.endDate)) {
        params.endDate = this.filters.endDate;
      }

      return this.$axios.get("nasabah/get-data-edit-nasabah", {
        params,
      }).then(res => {

        this.data = res.data.content
        this.totalRows = res.data.totalElements

        let pg = this.currentPage - 1

        let prev = pg * this.show + 1
        let limit = pg * this.show + this.show
        if (limit > this.totalRows) limit = this.totalRows

        this.totalViewText = "Menampilkan " + prev + " - " + limit + " dari " + this.totalRows + " entri"
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.reason == 'Nasabah tidak ditemukan') {
          this.$helper.parseError(this, error)
        } else {
          throw error
        }
      })
        .finally(() => {
          this.isBusy = false
        })
    },
    onLimitChange(newPerPage) {
      this.perPage = newPerPage
      this.getItems()
    },
    onPageChange(newPage) {
      this.getItems(newPage)
    },
    onSearch() {
      const isInvalidDateRange = this.$helper.isInvalidDateRange(this.filters.startDate, this.filters.endDate)

      if (isInvalidDateRange) {
        this.$helper.toastErr(this, 'Tanggal mulai tidak boleh lebih dari tanggal akhir')
        return;
      }

      this.setNoAnggota()
      this.getItems()
    },
    onReset() {
      this.filters = {
        noAnggota: '',
        status: this.STATUS_EDIT_ANGGOTA.PENDING,
        tipe: '',
        cabang: null,
        startDate: null,
        endDate: null,
      }

      this.clearNoAnggota()
      this.getItems()
    },
    onShowModalReject(row) {
      this.selectedRow = { row };
      this.$bvModal.show('modal-reject')
    },
    onShowModalRejectDetail() {
      if (this.$helper.isNullOrEmpty(this.noteReject)) {
        this.$helper.toastErr(this, 'Mohon isi alasan penolakan')
        return;
      }

      this.$bvModal.show('modal-reject-detail')
    },
    getStatus(status) {
      if (status === this.STATUS_EDIT_ANGGOTA.PENDING) return { text: 'Pending', class: 'status-box-md status-box-warning' };
      if (status === this.STATUS_EDIT_ANGGOTA.APPROVED) return { text: 'Disetujui', class: 'status-box-md status-box-success' }
      if (status === this.STATUS_EDIT_ANGGOTA.REJECTED) return { text: 'Ditolak', class: 'status-box-md status-box-danger' }

      return { text: '-', class: 'status-box-md status-box-default' }
    },
    handleEditApproval(payload) {
      this.selectedRow = payload;
      this.$bvModal.show('modal-approve')
    },
    handleReject() {
      const payload = {
        editId: this.selectedRow.row.id,
        status: this.STATUS_EDIT_ANGGOTA.REJECTED,
        noteApproval: this.noteReject,
      }

      this.isLoadingReject = true;
      this.$axios.post('/nasabah/approval-edit-nasabah', {}, { params: payload }).then(response => {
        this.$helper.toastSucc(this, response.data.name)
        this.$bvModal.hide('modal-reject')
        this.$bvModal.hide('modal-reject-detail')
        this.noteReject = ''
        this.getItems()
      }).catch(error => {
        this.$helper.parseError(this, error)
      }).finally(() => {
        this.isLoadingReject = false;
      })
    },
    handleApprove() {
      const payload = {
        editId: this.selectedRow.row.id,
        status: this.STATUS_EDIT_ANGGOTA.APPROVED,
        valueFinal: this.selectedRow.newValue,
        noteApproval: this.selectedRow.notes,
      }

      this.isLoadingApprove = true;
      this.$axios.post('/nasabah/approval-edit-nasabah', {}, { params: payload }).then(response => {
        this.$helper.toastSucc(this, response.data.name)
        this.$bvModal.hide('modal-approve')
        this.$bvModal.hide(`modal-approval-${this.selectedRow.row.id}`)
        this.getItems()
      }).catch(error => {
        this.$helper.parseError(this, error)
      }).finally(() => {
        this.isLoadingApprove = false;
      })
    },
    onShowModalIdentitas(row) {
      this.selectedRow = { row };
      this.$bvModal.show('modal-identitas')
      this.getListIdentitas()
    },
    getListIdentitas() {
      const params = {
        page: 0,
        size: 100,
        nasabahNo: this.selectedRow.row.noAnggota,
      }

      this.stateListIdentitas.isLoading = true;
      this.stateListIdentitas.isError = false;

      this.$axios.get('nasabah/get-nasabah-identitas', { params }).then(response => {
        this.stateListIdentitas.data = response.data.content[0].identitas;
      }).catch(error => {
        this.$helper.parseError(this, error);
        this.stateListIdentitas.isError = true;
      }).finally(() => {
        this.stateListIdentitas.isLoading = false;
      });
    },
    getCabang() {
      const getCabang = localStorage.getItem("cabang")
      const cabang = JSON.parse(getCabang);

      const mappingName = cabang.map(item => ({
        ...item,
        name: item.name.replace(/^\(\d+\)\s*/, "")
      }));

      this.optionsCabang = [
        { id: null, name: "Semua Cabang" },
        ...mappingName
      ]
    },
    formatDataType(text) {
      return text
        .replace(/\bsekarang\b/gi, '')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/\b\w/g, c => c.toUpperCase())
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 576;
    },
    onShowModalListRekening(row) {
      this.selectedRow = { row }
      this.$bvModal.show("modal-list-rekening-bank")
      this.getListRekening()
    },
    getListRekening() {
      this.stateListRekening.isLoading = true;
      this.stateListRekening.error = null;
      const id = this.selectedRow.row.nasabahId;
      this.$axios.get(`nasabah/list-bank/${id}`)
        .then((response) => {
          this.stateListRekening.data = response.data
        })
        .catch((error) => {
          const errorMessage = error.response.data.reason || error.response.data.error;
          this.stateListRekening.error = errorMessage;
        })
        .finally(() => {
          this.stateListRekening.isLoading = false;
        })
    },
    getPathPhotos(path) {
      const pathArray = Array.isArray(path) ? path : [path];

      const fullPaths = pathArray.map(item => {
          return `${this.$baseFilePathAws}${item}`;
      });

      return fullPaths;
    },
    getImageApproval(item) {
      const path = item.pathPhotos;
      if (Array.isArray(path) && path.length > 0) {
        return this.$baseFilePathAws + path[0];
      } 
      else if (typeof path === 'string' && path.length > 0) {
        return this.$baseFilePathAws + path;
      }
      
      return 'https://placehold.co/150x100?text=No+Image';
    },
    setNoAnggota() {
      this.$helper.setParams(this.$router, {
        noAnggota: this.filters.noAnggota,
      });
    },
    clearNoAnggota() {
      this.$helper.clearParams(this.$router, 'noAnggota');
    }
  },

  created() {
    this.init();
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
}
</script>